import styles from "./ProductCardHeader.module.scss";
import { Picture } from "../../../../Picture/Picture";
import LinkSolstice from "../../../../LinkSolstice/LinkSolstice";

interface ProductCardHeaderProps {
	planName: string;
	logoURL: string;
	imageURL: string;
	tagline: string;
	estimateDescription: string;
	estimateTitle: string;
	monthlyEstimate: string;
}

const applyHighlight = (text: string) => {
	const title = text.split(" ");
	const index = title.indexOf("Solstice");

	if (index !== -1) {
		title[index] = `<span>${title[index]}</span>`;
	}
	return <div dangerouslySetInnerHTML={{ __html: title.join(" ") }} />;
};

export const ProductCardHeader = ({
	planName,
	logoURL,
	imageURL,
	tagline,
	monthlyEstimate,
	estimateTitle,
	estimateDescription,
}: ProductCardHeaderProps) => {
	return (
		<div className={styles["product-header"]}>
			<div className={styles["product-header__content"]}>
				{logoURL && (
					<img
						className={styles["product-header__logo"]}
						alt=""
						src={logoURL}
						width={75}
						height={75}
					/>
				)}
				<h3 className={styles["product-header__heading"]}>{applyHighlight(planName)}</h3>
				<p className={styles["product-header__tagline"]}>{tagline}</p>
			</div>
			<div className={styles["product-header__image"]}>
				{imageURL && (
					<Picture
						alt=""
						sanityImage={imageURL}
						width={260}
						height={202}
					/>
				)}
			</div>
		</div>
	);
};
